// Locale -> storefront suffix per retailer. A suffix is listed only where the retailer really
// runs that storefront (verified against live DNS and TLS certificates); everything else falls
// back to .com, which all of them have.
const AMAZON_EXTENSIONS: Record<string, string> = {
  ar_sa: 'sa',
  ar_eg: 'eg',
  ar_ae: 'ae',
  bg_bg: 'com',
  da_da: 'com',
  de_de: 'de',
  el_gr: 'com',
  en_ae: 'ae',
  en_br: 'com.br',
  en_eg: 'eg',
  en_sg: 'sg',
  en_us: 'com',
  en_fr: 'fr',
  en_in: 'in',
  en_ca: 'ca',
  en_gb: 'co.uk',
  en_au: 'com.au',
  en_be: 'com.be',
  en_es: 'es',
  en_nl: 'nl',
  en_sa: 'sa',
  en_se: 'se',
  es_mx: 'com.mx',
  es_es: 'es',
  fi_fi: 'com',
  fr_fr: 'fr',
  fr_ca: 'ca',
  fr_be: 'com.be',
  hi_in: 'in',
  id_id: 'com',
  it_it: 'it',
  ja_jp: 'co.jp',
  ko_kr: 'com',
  ms_ma: 'com',
  nl_nl: 'nl',
  nl_be: 'com.be',
  no_no: 'com',
  pl_pl: 'pl',
  pt_br: 'com.br',
  pt_pt: 'com',
  ro_ro: 'com',
  ru_ru: 'com',
  sv_se: 'se',
  th_th: 'com',
  tr_tr: 'com.tr',
  uk_ua: 'com',
  vi_vi: 'com',
  zh_cn: 'com',
  zh_hk: 'com',
  zh_sg: 'sg',
  zh_tw: 'com'
}

// Walmart also trades in Central America and South Africa, which no shipped locale maps onto.
const WALMART_EXTENSIONS: Record<string, string> = {
  en_ca: 'ca',
  fr_ca: 'ca',
  es_mx: 'com.mx',
  zh_cn: 'cn'
}

// Costco also trades in Iceland and New Zealand, which no shipped locale maps onto.
const COSTCO_EXTENSIONS: Record<string, string> = {
  en_au: 'com.au',
  en_ca: 'ca',
  fr_ca: 'ca',
  en_es: 'es',
  es_es: 'es',
  en_fr: 'fr',
  fr_fr: 'fr',
  en_gb: 'co.uk',
  en_se: 'se',
  sv_se: 'se',
  es_mx: 'com.mx',
  ja_jp: 'co.jp',
  ko_kr: 'co.kr',
  zh_cn: 'cn',
  zh_tw: 'com.tw'
}

// Nike's other country addresses redirect into country paths of its .com site, and its British
// one belongs to an unrelated company — China is the one storefront it runs on its own domain.
const NIKE_EXTENSIONS: Record<string, string> = {
  zh_cn: 'com.cn'
}

// Retailers absent here run a single .com storefront: Target, Chewy, Kroger, and the standard
// store, whose name is the researcher's own text rather than a real brand.
const STORE_EXTENSIONS: Record<string, Record<string, string>> = {
  amazonw: AMAZON_EXTENSIONS,
  walmartw: WALMART_EXTENSIONS,
  costcow: COSTCO_EXTENSIONS,
  nikew: NIKE_EXTENSIONS
}

export const storeExtension = (store: string, localeID?: string): string =>
  (localeID && STORE_EXTENSIONS[store]?.[localeID.toLowerCase()]) || 'com'
